import React from "react";
import {
  apiPaths,
  postData,
} from "../../platform-components/api-integration-util";
import logo from "../../../images/logo.jpg";
import { getRoleNameList, getUserDetails } from "../utils/shared-data.service";
import { useHistory } from "react-router-dom";

function AppHeader(props) {
  const history = useHistory();
  const logOut = async () => {
    try {
      await postData(apiPaths.logout, { data: {} });
    } catch (e) {
    }
    localStorage.clear();
    try {
      history.push('/login');
    } catch (e) {
    }
    window.location.reload();
  };

  const handleChangePass = () => props.history.push("/app/change-password");

  return (
    <div>
      <header className="main-header">
        <div className="logo">
          <span className="logo-mini">
            <img src="logo.png" alt="arise" />
          </span>
          <span className="logo-lg">
            <img src={logo} alt="arise" />
            <span className="logo-text">Arise Academic Portal</span>
          </span>
        </div>
        <nav className="navbar navbar-static-top">
          <div className="sidebar-toggle" data-toggle="offcanvas" role="button">
            <span className="sr-only">Toggle navigation</span>
          </div>

          <div className="navbar-custom-menu">
            <ul className="nav navbar-nav">
              <li className="dropdown user user-menu">
                <div className="dropdown-toggle" data-toggle="dropdown">
                  <div className="login-details-navbar">
                    <div className="login-first-letter">
                      {getUserDetails().firstName?.charAt(0)?.toUpperCase() ||
                        "A"}
                    </div>
                  </div>
                </div>
                <ul className="dropdown-menu">
                  {getRoleNameList().includes("Admin") && (
                    <li
                      className="dropdown-item"
                      onClick={() => props.history.push("/app/adminPanel")}
                    >
                      <span role="button">
                        {getUserDetails().firstName || "Admin"}
                      </span>
                    </li>
                  )}
                  <div class="dropdown-divider"></div>
                  <li className="dropdown-item" onClick={handleChangePass}>
                    <span role="button">Change Password</span>
                  </li>
                  <div class="dropdown-divider"></div>
                  <li className="dropdown-item" onClick={logOut}>
                    <span role="button">Logout</span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    </div>
  );
}
export default AppHeader;
